import { useMemo, useCallback } from "react";
import RatingBadge from "@/components/widgets/rating-badge";
import { useWidgetFont } from "../hooks/use-widget-font";
import type { WidgetTemplateProps } from "./template-router";

export default function TemplateClassicRatingBadge({ previewData, layoutConfig, templateDetail }: WidgetTemplateProps) {
	const fontStyle = useWidgetFont(layoutConfig, templateDetail);

	const getLayoutValue = useCallback(
		(key: string, fallback: unknown = "") => {
			if (layoutConfig[key] !== undefined) return layoutConfig[key];
			if (templateDetail?.defaults?.layout?.[key] !== undefined) return templateDetail.defaults.layout[key];
			return fallback;
		},
		[layoutConfig, templateDetail],
	);

	const ratingPreview = useMemo(() => {
		if (previewData && "metrics" in previewData) return previewData.metrics;
		return { metric: "average_rating", value: 5.0, precision: 1, count: 154 };
	}, [previewData]);

	const ratingStarColor = String(getLayoutValue("rating_star_color", "") || "") || undefined;
	const ratingTileTextColor = String(getLayoutValue("rating_tile_text_color", "") || "") || undefined;
	const ratingTileBackgroundColor = String(getLayoutValue("rating_tile_background_color", "") || "") || undefined;
	const countTextColor = String(getLayoutValue("count_text_color", "") || "") || undefined;

	return (
		<div style={fontStyle}>
			<RatingBadge rating={ratingPreview.value} precision={ratingPreview.precision} totalReviews={ratingPreview.count} badgeColor={String(getLayoutValue("badge_color", "#1f1f1f"))} showStars={true} showCount={true} ratingStarColor={ratingStarColor} ratingTileTextColor={ratingTileTextColor} ratingTileBackgroundColor={ratingTileBackgroundColor} countTextColor={countTextColor} />
		</div>
	);
}
